// === Filter group toggle ===
function toggleFilterGroup(trigger) {
  var group = trigger.closest('.filter-group');
  if (!group) return;
  group.classList.toggle('is-expanded');
}

function applyFilterGroupSearch(input) {
  if (!input) return;

  var group = input.closest('.filter-group');
  if (!group) return;

  var valuesWrap = group.querySelector('[data-filter-values]');
  var emptyMsg = group.querySelector('[data-filter-search-empty]');
  var query = input.value.trim().toLowerCase();
  var visibleCount = 0;

  if (!valuesWrap) return;

  valuesWrap.querySelectorAll('[data-filter-value]').forEach(function(link) {
    var labelEl = link.querySelector('.filter-value__label');
    var labelText = (link.getAttribute('data-filter-label') || (labelEl ? labelEl.textContent : '')).trim().toLowerCase();
    var matches = !query || labelText.indexOf(query) !== -1 || link.classList.contains('is-active');
    link.hidden = !matches;
    if (matches) visibleCount += 1;
  });

  if (emptyMsg) {
    emptyMsg.hidden = visibleCount > 0;
  }
}

function initFilterGroupSearch(root) {
  var scope = root || document;
  scope.querySelectorAll('[data-filter-search]').forEach(function(input) {
    applyFilterGroupSearch(input);
  });
}

// === AJAX Collection Filtering ===
(function() {
  var filterSidebar = document.getElementById('collectionFilters');
  var dynamicArea = document.getElementById('collectionDynamic');
  if (!filterSidebar || !dynamicArea) return;

  var isLoading = false;
  var isPopstate = false;
  var currentGridView = 'two';
  var drawerOpener = null;
  var filterDrawerSnapshot = null;
  var pendingFilterUrl = null;

  function isMobileFilterDrawer() {
    return window.innerWidth <= 560;
  }

  function syncFilterDrawerButtons(isOpen) {
    document.querySelectorAll('[data-filter-drawer-open]').forEach(function(button) {
      button.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  function setFilterDrawer(isOpen, restoreFocus, keepChanges) {
    if (isOpen) {
      filterDrawerSnapshot = filterSidebar.innerHTML;
      pendingFilterUrl = new URL(window.location.href);
    } else if (!keepChanges && filterDrawerSnapshot !== null) {
      filterSidebar.innerHTML = filterDrawerSnapshot;
      initFilterGroupSearch(filterSidebar);
    }

    document.body.classList.toggle('is-collection-filter-open', isOpen);
    syncFilterDrawerButtons(isOpen);

    if (isOpen) {
      var closeButton = document.querySelector('[data-filter-drawer-close]');
      if (closeButton) closeButton.focus();
      return;
    }

    filterDrawerSnapshot = null;
    pendingFilterUrl = null;

    if (restoreFocus !== false && drawerOpener && drawerOpener.isConnected) {
      drawerOpener.focus();
    }
  }

  function applyCollectionGridView(root) {
    var scope = root || document;
    scope.querySelectorAll('.collection-grid').forEach(function(grid) {
      grid.classList.toggle('is-single-column', currentGridView === 'one');
    });

    document.querySelectorAll('[data-grid-view]').forEach(function(button) {
      var isActive = button.getAttribute('data-grid-view') === currentGridView;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  }

  function setCustomSortOpen(sort, isOpen, focusOption) {
    if (!sort) return;
    var trigger = sort.querySelector('[data-custom-sort-trigger]');
    var menu = sort.querySelector('[data-custom-sort-menu]');
    if (!trigger || !menu) return;

    sort.classList.toggle('is-open', isOpen);
    trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    menu.hidden = !isOpen;

    if (isOpen && focusOption) {
      var selected = menu.querySelector('[aria-selected="true"]');
      var first = menu.querySelector('[data-custom-sort-option]');
      (selected || first || trigger).focus();
    }
  }

  function closeCustomSorts(except) {
    document.querySelectorAll('[data-custom-sort].is-open').forEach(function(sort) {
      if (sort !== except) setCustomSortOpen(sort, false);
    });
  }

  function applySortValue(sort, value, label) {
    var shouldStage = isMobileFilterDrawer()
      && document.body.classList.contains('is-collection-filter-open')
      && filterSidebar.contains(sort);
    var url = shouldStage && pendingFilterUrl ? new URL(pendingFilterUrl.toString()) : new URL(window.location.href);
    var defaultSort = sort.getAttribute('data-collection-default-sort');
    if (defaultSort && value === defaultSort) {
      url.searchParams.delete('sort_by');
    } else {
      url.searchParams.set('sort_by', value);
    }
    url.searchParams.delete('page');

    if (shouldStage) {
      pendingFilterUrl = url;
      var current = sort.querySelector('[data-custom-sort-current]');
      if (current && label) current.textContent = label;
      sort.querySelectorAll('[data-custom-sort-option]').forEach(function(option) {
        var isSelected = option.getAttribute('data-custom-sort-option') === value;
        option.classList.toggle('is-selected', isSelected);
        option.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      });
      return;
    }

    updatePage(url.toString());
  }

  function updatePage(url, opts) {
    opts = opts || {};
    if (isLoading) return;
    isLoading = true;

    dynamicArea.classList.add('is-loading');

    fetch(url)
      .then(function(res) { return res.text(); })
      .then(function(html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var expandedIndexes = [];
        filterSidebar.querySelectorAll('.filter-group.is-expanded').forEach(function(g) {
          expandedIndexes.push(g.getAttribute('data-filter-index'));
        });
        var priceMin = filterSidebar.querySelector('[data-price-min]');
        var priceMax = filterSidebar.querySelector('[data-price-max]');
        var priceMinVal = priceMin ? priceMin.value : '';
        var priceMaxVal = priceMax ? priceMax.value : '';
        var searchQueries = {};
        filterSidebar.querySelectorAll('[data-filter-search]').forEach(function(input) {
          var searchGroup = input.closest('.filter-group');
          var searchIdx = searchGroup ? searchGroup.getAttribute('data-filter-index') : '';
          if (searchIdx && input.value) searchQueries[searchIdx] = input.value;
        });

        var newFilters = doc.getElementById('collectionFilters');
        if (newFilters) {
          filterSidebar.innerHTML = newFilters.innerHTML;
          expandedIndexes.forEach(function(idx) {
            var group = filterSidebar.querySelector('.filter-group[data-filter-index="' + idx + '"]');
            if (group) group.classList.add('is-expanded');
          });
          var newMin = filterSidebar.querySelector('[data-price-min]');
          var newMax = filterSidebar.querySelector('[data-price-max]');
          if (newMin) newMin.value = priceMinVal;
          if (newMax) newMax.value = priceMaxVal;
          filterSidebar.querySelectorAll('[data-filter-search]').forEach(function(input) {
            var restoreGroup = input.closest('.filter-group');
            var restoreIdx = restoreGroup ? restoreGroup.getAttribute('data-filter-index') : '';
            if (restoreIdx && searchQueries[restoreIdx]) {
              input.value = searchQueries[restoreIdx];
              applyFilterGroupSearch(input);
            }
          });
        }

        var newDynamic = doc.getElementById('collectionDynamic');
        if (newDynamic) {
          dynamicArea.innerHTML = newDynamic.innerHTML;
          initProductCardVideos(dynamicArea);
          applyCollectionGridView(dynamicArea);
          syncFilterDrawerButtons(document.body.classList.contains('is-collection-filter-open'));
        }

        if (!isPopstate) {
          history.pushState({}, '', url);
        }

        // On pagination, jump to the top of the product list so new cards are in view
        if (opts.scrollToTop) {
          var header = document.getElementById('siteHeader');
          var offset = header ? header.offsetHeight : 0;
          var top = dynamicArea.getBoundingClientRect().top + window.scrollY - offset - 16;
          window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
        }

        // Re-trigger reveal: first 1.3 viewports instant, rest on scroll
        setTimeout(function() {
          var instantBottom = window.innerHeight * 1.3;
          document.querySelectorAll('.reveal:not(.is-visible)').forEach(function(el) {
            if (el.getBoundingClientRect().top < instantBottom) {
              el.classList.add('is-visible', 'is-reveal-instant');
              return;
            }
            var obs = new IntersectionObserver(function(entries) {
              entries.forEach(function(entry) {
                if (entry.isIntersecting) {
                  entry.target.classList.add('is-visible');
                  obs.unobserve(entry.target);
                }
              });
            }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
            obs.observe(el);
          });
        }, 100);
      })
      .catch(function() {
        window.location.href = url;
      })
      .finally(function() {
        isLoading = false;
        isPopstate = false;
        dynamicArea.classList.remove('is-loading');
      });
  }

  initFilterGroupSearch(filterSidebar);
  applyCollectionGridView(document);

  document.addEventListener('click', function(e) {
    var drawerOpen = e.target.closest('[data-filter-drawer-open]');
    if (drawerOpen) {
      drawerOpener = drawerOpen;
      setFilterDrawer(true);
      return;
    }

    var filterApply = e.target.closest('[data-filter-apply]');
    if (filterApply) {
      var applyUrl = pendingFilterUrl ? pendingFilterUrl.toString() : window.location.href;
      setFilterDrawer(false, true, true);
      updatePage(applyUrl);
      return;
    }

    if (e.target.closest('[data-filter-drawer-close]')) {
      setFilterDrawer(false);
      return;
    }

    var viewButton = e.target.closest('[data-grid-view]');
    if (viewButton) {
      currentGridView = viewButton.getAttribute('data-grid-view') === 'one' ? 'one' : 'two';
      applyCollectionGridView(document);
      closeCustomSorts();
      return;
    }

    var sortTrigger = e.target.closest('[data-custom-sort-trigger]');
    if (sortTrigger) {
      var triggerSort = sortTrigger.closest('[data-custom-sort]');
      var shouldOpen = !triggerSort.classList.contains('is-open');
      closeCustomSorts(triggerSort);
      setCustomSortOpen(triggerSort, shouldOpen);
      return;
    }

    var sortOption = e.target.closest('[data-custom-sort-option]');
    if (sortOption) {
      var optionSort = sortOption.closest('[data-custom-sort]');
      var sortValue = sortOption.getAttribute('data-custom-sort-option');
      var sortLabel = sortOption.textContent.trim();
      setCustomSortOpen(optionSort, false);
      applySortValue(optionSort, sortValue, sortLabel);
      return;
    }

    if (!e.target.closest('[data-custom-sort]')) closeCustomSorts();
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && document.body.classList.contains('is-collection-filter-open')) {
      setFilterDrawer(false);
    }

    var sort = e.target.closest('[data-custom-sort]');
    if (!sort) return;

    var trigger = e.target.closest('[data-custom-sort-trigger]');
    var option = e.target.closest('[data-custom-sort-option]');
    if (e.key === 'Escape' && sort.classList.contains('is-open')) {
      e.preventDefault();
      setCustomSortOpen(sort, false);
      var sortTrigger = sort.querySelector('[data-custom-sort-trigger]');
      if (sortTrigger) sortTrigger.focus();
      return;
    }

    if (trigger && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) {
      e.preventDefault();
      closeCustomSorts(sort);
      setCustomSortOpen(sort, true, true);
      return;
    }

    if (option && ['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(e.key) !== -1) {
      e.preventDefault();
      var options = Array.prototype.slice.call(sort.querySelectorAll('[data-custom-sort-option]'));
      var index = options.indexOf(option);
      if (e.key === 'Home') index = 0;
      if (e.key === 'End') index = options.length - 1;
      if (e.key === 'ArrowDown') index = (index + 1) % options.length;
      if (e.key === 'ArrowUp') index = (index - 1 + options.length) % options.length;
      options[index].focus();
    }
  });

  document.addEventListener('focusin', function(e) {
    var openSort = document.querySelector('[data-custom-sort].is-open');
    if (openSort && !openSort.contains(e.target)) closeCustomSorts();
  });

  window.addEventListener('resize', function() {
    if (window.innerWidth > 560 && document.body.classList.contains('is-collection-filter-open')) {
      setFilterDrawer(false, false);
    }
  });

  filterSidebar.addEventListener('input', function(e) {
    var searchInput = e.target.closest('[data-filter-search]');
    if (searchInput) {
      applyFilterGroupSearch(searchInput);
      return;
    }
  });

  // Debounced price input handler
  var priceDebounce = null;
  filterSidebar.addEventListener('input', function(e) {
    var input = e.target.closest('[data-price-min], [data-price-max]');
    if (!input) return;
    // Allow only positive integers
    var raw = input.value.replace(/[^0-9]/g, '');
    if (input.value !== raw) input.value = raw;

    if (isMobileFilterDrawer() && document.body.classList.contains('is-collection-filter-open')) {
      if (!pendingFilterUrl) pendingFilterUrl = new URL(window.location.href);
      var pendingGroup = input.closest('.filter-group__body');
      var pendingMinInput = pendingGroup.querySelector('[data-price-min]');
      var pendingMaxInput = pendingGroup.querySelector('[data-price-max]');
      var pendingMin = pendingMinInput && pendingMinInput.value ? parseInt(pendingMinInput.value, 10) : '';
      var pendingMax = pendingMaxInput && pendingMaxInput.value ? parseInt(pendingMaxInput.value, 10) : '';
      if (pendingMin) pendingFilterUrl.searchParams.set('filter.v.price.gte', pendingMin); else pendingFilterUrl.searchParams.delete('filter.v.price.gte');
      if (pendingMax) pendingFilterUrl.searchParams.set('filter.v.price.lte', pendingMax); else pendingFilterUrl.searchParams.delete('filter.v.price.lte');
      pendingFilterUrl.searchParams.delete('page');
      return;
    }

    clearTimeout(priceDebounce);
    priceDebounce = setTimeout(function() {
      var group = input.closest('.filter-group__body');
      var minInput = group.querySelector('[data-price-min]');
      var maxInput = group.querySelector('[data-price-max]');
      var min = minInput && minInput.value ? parseInt(minInput.value, 10) : '';
      var max = maxInput && maxInput.value ? parseInt(maxInput.value, 10) : '';
      var url = new URL(window.location.href);
      if (min) url.searchParams.set('filter.v.price.gte', min); else url.searchParams.delete('filter.v.price.gte');
      if (max) url.searchParams.set('filter.v.price.lte', max); else url.searchParams.delete('filter.v.price.lte');
      updatePage(url.toString());
    }, 500);
  });

  filterSidebar.addEventListener('click', function(e) {
    var link = e.target.closest('.filter-value');
    if (!link) return;
    e.preventDefault();

    var param = link.getAttribute('data-filter-param');
    var value = link.getAttribute('data-filter-param-value');
    var group = link.closest('.filter-group');
    var groupLabel = group && group.querySelector('.filter-group__label');
    var isGenusFilter = param && (/(?:^|\.)genus$/i.test(param) || (groupLabel && groupLabel.textContent.trim().toLowerCase() === 'genus'));
    var isStaged = isMobileFilterDrawer() && document.body.classList.contains('is-collection-filter-open');

    if (isGenusFilter && value !== null) {
      var genusUrl = new URL(isStaged && pendingFilterUrl ? pendingFilterUrl.toString() : window.location.href);
      var wasActive = link.getAttribute('data-filter-active') === 'true';
      genusUrl.searchParams.delete(param);
      if (!wasActive) genusUrl.searchParams.set(param, value);
      genusUrl.searchParams.delete('page');

      if (isStaged) {
        pendingFilterUrl = genusUrl;
        group.querySelectorAll('[data-filter-value]').forEach(function(option) {
          var isActive = !wasActive && option === link;
          option.classList.toggle('is-active', isActive);
          option.setAttribute('data-filter-active', isActive ? 'true' : 'false');
        });
        var searchInput = group.querySelector('[data-filter-search]');
        if (searchInput) applyFilterGroupSearch(searchInput);
      } else {
        updatePage(genusUrl.toString());
      }
      return;
    }

    if (isStaged) {
      if (!pendingFilterUrl) pendingFilterUrl = new URL(window.location.href);
      if (param && value !== null) {
        var values = pendingFilterUrl.searchParams.getAll(param);
        var valueIndex = values.indexOf(value);
        if (valueIndex === -1) {
          values.push(value);
          link.classList.add('is-active');
          link.setAttribute('data-filter-active', 'true');
        } else {
          values.splice(valueIndex, 1);
          link.classList.remove('is-active');
          link.setAttribute('data-filter-active', 'false');
        }
        pendingFilterUrl.searchParams.delete(param);
        values.forEach(function(filterValue) {
          pendingFilterUrl.searchParams.append(param, filterValue);
        });
        pendingFilterUrl.searchParams.delete('page');
      }
      return;
    }

    updatePage(link.href);
  });

  // Intercept pagination clicks inside dynamic area
  dynamicArea.addEventListener('click', function(e) {
    var link = e.target.closest('.pagination__page');
    if (!link || !link.href) return;
    e.preventDefault();
    updatePage(link.href, { scrollToTop: true });
  });

  document.addEventListener('click', function(e) {
    var pill = e.target.closest('.active-filter__pill');
    if (pill) {
      e.preventDefault();
      updatePage(pill.href);
      return;
    }
    var clear = e.target.closest('.active-filter__clear');
    if (clear) {
      e.preventDefault();
      updatePage(clear.href);
    }
  });

  window.addEventListener('popstate', function() {
    isPopstate = true;
    updatePage(window.location.href);
  });
})();
